import React, { useState } from 'react';
import { View, Text, TextInput, TouchableOpacity, ScrollView, ImageBackground, Animated, Platform } from 'react-native';
import { getFirestore, collection, addDoc, getDoc, doc } from 'firebase/firestore';
import { globalStyles } from '../styles/globalStyles';
import { addVenueStyles } from '../styles/addVenueStyles';
import { getAuth } from 'firebase/auth';
import { BackgroundVideo } from '../components/BackgroundVideo';
import { useAnimation } from '../hooks/useAnimation';
import { colors } from '../styles/theme';
export function AddVenue({ navigation }) {
  const [venueData, setVenueData] = useState({
    name: '',
    state: '',
    city: '',
    website: '',
    capacity: '',
    affiliate: '',
    stage: '',
    specSheetLink: '',
    power: '',
    lightingControl: '',
    lightingFixtures: '',
    video: '',
    foh: '',
    pa: '',
    monitors: '',
    adaAccessibilityArtist: '',    backstage: '',
    backline: '',
    merch: '',
    parking: '',
    shorePower: '',
    notes: '',
    mapEmbedLink: '',
  });

  const handleSubmit = async () => {
    try {
      const db = getFirestore();
      const auth = getAuth();

      if (!venueData.name || !venueData.city || !venueData.state) {
        alert('Please fill in at least the venue name, city, and state.');
        return;
      }

      // Get current user's data from Firestore
      const userDoc = await getDoc(doc(db, 'users', auth.currentUser?.uid || 'anonymous'));
      const userData = userDoc.exists() ? userDoc.data() : {};

      const venueDoc = {
        ...venueData,
        status: 'pending',
        createdAt: new Date(),
        updatedAt: new Date(),
        createdBy: auth.currentUser?.uid || 'anonymous',
        submittedBy: {
          uid: auth.currentUser?.uid || 'anonymous',
          email: auth.currentUser?.email || 'anonymous',
          username: userData.username || 'Anonymous',
          firstName: userData.firstName || '',
          lastName: userData.lastName || '',
          photoURL: userData.photoURL || null,
          verificationStatus: userData.verificationStatus || null
        }
      };

      await addDoc(collection(db, 'new_venues'), venueDoc);
      alert('Venue submitted successfully! It will be reviewed by an admin.');
      navigation.navigate('VenueList');
    } catch (error) {
      console.error('Error submitting venue:', error);
      alert('Error submitting venue. Please try again.');
    }
  };

  const renderInput = (label, field, placeholder = '', multiline = false) => (
    <View style={addVenueStyles.inputContainer}>
      <Text style={addVenueStyles.label}>{label}</Text>
      <TextInput
        style={[
          addVenueStyles.input,
          multiline && addVenueStyles.multilineInput
        ]}
        value={venueData[field]}
        onChangeText={(text) => setVenueData(prev => ({ ...prev, [field]: text }))}
        placeholder={placeholder}
        placeholderTextColor="rgba(0, 0, 0, 0.6)"
        multiline={multiline}
      />
    </View>
  );

  const fadeIn = useAnimation(0, 1, 600);
  const slideUp = useAnimation(40, 0, 600);

  return (
    <View style={[globalStyles.container, { minWidth: '100vw' }]}>
      <BackgroundVideo />
      <View style={[globalStyles.overlay, { minWidth: '100vw' }]}>
        <ScrollView style={addVenueStyles.scrollView}>
          <View style={addVenueStyles.formContainer}>
            <Text style={addVenueStyles.title}>Add a Venue</Text>
            
            <View style={addVenueStyles.section}>
              <Text style={addVenueStyles.sectionTitle}>Basic Information</Text>
              {renderInput('Venue Name*', 'name', 'Enter venue name')}
              {renderInput('City*', 'city', 'Enter city')}
              {renderInput('State*', 'state', 'Enter state')}
              {renderInput('Website', 'website', 'Enter website URL')}
              {renderInput('Capacity', 'capacity', 'Enter venue capacity')}
              {renderInput('Affiliate', 'affiliate', 'Enter venue affiliate')}
            </View>

            <View style={addVenueStyles.section}>
              <Text style={addVenueStyles.sectionTitle}>Technical Details</Text>
              {renderInput('Stage Dimensions', 'stage', 'Enter stage dimensions')}
              {renderInput('Power', 'power', 'Enter power specifications')}
              {renderInput('Lighting Control', 'lightingControl', 'Enter lighting control details')}
              {renderInput('Lighting Fixtures', 'lightingFixtures', 'Enter lighting fixture details')}
              {renderInput('Video', 'video', 'Enter video equipment details')}
              {renderInput('FOH', 'foh', 'Enter FOH details')}
              {renderInput('PA System', 'pa', 'Enter PA system details')}
              {renderInput('Monitors', 'monitors', 'Enter monitor details')}
            </View>

            <View style={addVenueStyles.section}>
              <Text style={addVenueStyles.sectionTitle}>Facilities</Text>
              {renderInput('ADA Accessibility for Artist', 'adaAccessibilityArtist', 'Enter ADA accessibility details for artists')}              {renderInput('Backstage', 'backstage', 'Enter backstage details')}
              {renderInput('Backline', 'backline', 'Enter backline details')}              {renderInput('Merch', 'merch', 'Enter merch space details')}
              {renderInput('Parking', 'parking', 'Enter parking details')}
              {renderInput('Shore Power', 'shorePower', 'Enter shore power details')}
            </View>

            <View style={addVenueStyles.section}>
              <Text style={addVenueStyles.sectionTitle}>Additional Information</Text>
              {renderInput('Spec Sheet Link', 'specSheetLink', 'Enter spec sheet URL')}
              {renderInput('Map Embed Link', 'mapEmbedLink', 'Enter Google Maps embed code')}
              {renderInput('Notes', 'notes', 'Enter any additional notes', true)}
            </View>

            <TouchableOpacity
              style={[
                addVenueStyles.submitButton,
                Platform.OS === 'web' && {
                  transition: 'all 0.2s ease-in-out',
                  ':hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                    backgroundColor: colors.primary + 'dd',
                  }
                }
              ]}
              onPress={handleSubmit}
            >
              <Text style={addVenueStyles.submitButtonText}>Add Venue</Text>
            </TouchableOpacity>
          </View>
        </ScrollView>
      </View>
    </View>
  );
} 

